export const character =[
    {
        "_id": "5a0fa4daae5bc100213c232e",
        "name": "Hannah Abbott",
        "role": "student",
        "house": "Hufflepuff",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a0fa54aae5bc100213c232f",
        "house": "unknown",
        "name": "Bathsheda Babbling",
        "role": "Professor, Ancient Runes",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a0fa5deae5bc100213c2330",
        "house": "unknown",
        "name": "Ludo Bagman",
        "role": "Head, Department of Magical Games and Sports",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a0fa60aae5bc100213c2331",
        "house": "unknown",
        "name": "Bathilda Bagshot",
        "role": "Author, A History Of Magic",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a0fa648ae5bc100213c2332",
        "name": "Katie Bell",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "boggart": "Lord Voldemort",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a0fa67dae5bc100213c2333",
        "name": "Cuthbert Binns",
        "role": "Professor, History of Magic",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "ghost"
    },
    {
        "_id": "5a0fa6bbae5bc100213c2334",
        "name": "Phineas Nigellus Black",
        "role": "(Formerly) Headmaster of Hogwarts",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a0fa772ae5bc100213c2337",
        "name": "Regulus Black",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a0fa7dcae5bc100213c2338",
        "name": "Sirius Black",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Padfoot",
        "animagus": "black dog",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a0fa842ae5bc100213c2339",
        "name": "Amelia Bones",
        "role": "Head, Department of Magical Law Enforcement",
        "house": "Hufflepuff",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a0fa86dae5bc100213c233a",
        "name": "Susan Bones",
        "role": "student",
        "house": "Hufflepuff",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a0fa8a6ae5bc100213c233b",
        "name": "Terry Boot",
        "role": "student",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a107e1ae0686c0021283b19",
        "name": "Lavender Brown",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "boggart": "rat",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a107e4ae0686c0021283b1a",
        "name": "Millicent Bulstrode",
        "role": "student",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a107ee3e0686c0021283b1c",
        "house": "unknown",
        "name": "Frank Bryce",
        "role": "Gardener, Riddle Family",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "muggle",
        "species": "human"
    },
    {
        "_id": "5a107ebee0686c0021283b1b",
        "house": "unknown",
        "name": "Charity Burbage",
        "role": "Professor, Muggle Studies",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "boggart": "Lord Voldemort",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a107f17e0686c0021283b1d",
        "house": "unknown",
        "name": "Alecto Carrow",
        "role": "Professor, Muggle Studies",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a107f60e0686c0021283b1e",
        "house": "unknown",
        "name": "Amycus Carrow",
        "role": "Professor, Dark Arts",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a107f9be0686c0021283b1f",
        "house": "unknown",
        "name": "Reginald Cattermole",
        "role": "Employee, Magical Maintenance Department",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a107fc9e0686c0021283b20",
        "house": "unknown",
        "name": "Mary Cattermole",
        "wand": "Cherry, 8 3/4\", unicorn hair",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a107ffee0686c0021283b21",
        "name": "Cho Chang",
        "role": "Student",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "patronus": "swan",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a108023e0686c0021283b22",
        "name": "Penelope Clearwater",
        "role": "Student",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Penny",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a108047e0686c0021283b23",
        "name": "Michael Corner",
        "role": "Student",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a1093eb3dc2080021cd8753",
        "name": "Crabbe",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a10942a3dc2080021cd8754",
        "name": "Vincent Crabbe",
        "role": "Student",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "boggart": "Lord Voldemort",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a10944f3dc2080021cd8755",
        "name": "Colin Creevey",
        "role": "Student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "muggle-born",
        "species": "human"
    },
    {
        "_id": "5a10947c3dc2080021cd8756",
        "name": "Dennis Creevey",
        "role": "Student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "muggle-born",
        "species": "human"
    },
    {
        "_id": "5a1094a53dc2080021cd8757",
        "house": "unknown",
        "name": "Dirk Cresswell",
        "role": "Head, Goblin Liason Office",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "muggle-born",
        "species": "human"
    },
    {
        "_id": "5a1094dc3dc2080021cd8758",
        "house": "unknown",
        "name": "Bartemius Crouch Sr.",
        "role": "Head, Department of International Magical Cooperation",
        "alias": "Barty",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1094fa3dc2080021cd8759",
        "house": "unknown",
        "name": "Bartemius Crouch Jr.",
        "alias": "Barty",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a10951a3dc2080021cd875a",
        "house": "unknown",
        "name": "John Dawlish",
        "role": "Auror",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1095693dc2080021cd875b",
        "house": "unknown",
        "name": "Fleur Delacour",
        "role": "Student",
        "school": "Beauxbatons Academy of Magic",
        "wand": "Rosewood, 9 1/2\", veela hair",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "quarter-villa",
        "species": "part-human"
    },
    {
        "_id": "5a1095873dc2080021cd875c",
        "house": "unknown",
        "name": "Gabrielle Delacour",
        "role": "Student",
        "school": "Beauxbatons Academy of Magic",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "quarter-villa",
        "species": "part-human"
    },
    {
        "_id": "5a1095af3dc2080021cd875d",
        "house": "unknown",
        "name": "Dedalus Diggle",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1095e53dc2080021cd875e",
        "house": "unknown",
        "name": "Amos Diggory",
        "role": "Employee, Department for the Regulation and Control of Magical Creatures",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1096253dc2080021cd875f",
        "house": "unknown",
        "name": "Cedric Diggory",
        "role": "Student",
        "house": "Hufflepuff",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "wand": "Ash, 12 1/4\", unicorn hair",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a10964d3dc2080021cd8760",
        "house": "unknown",
        "name": "Elphias Doge",
        "role": "Special Advisor to the Wizengamot",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1096743dc2080021cd8761",
        "house": "unknown",
        "name": "Antonin Dolohov",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1096b33dc2080021cd8762",
        "house": "unknown",
        "name": "Aberforth Dumbledore",
        "role": "Owner, Hog's Head Inn",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Ab",
        "patronus": "goat",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a1097653dc2080021cd8763",
        "house": "unknown",
        "name": "Albus Dumbledore",
        "role": "Headmaster, Hogwarts",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "wand": "Elder, 15\", thestral tail hair",
        "boggart": "Ariana (sister)",
        "patronus": "phoenix",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a10977d3dc2080021cd8764",
        "house": "unknown",
        "name": "Ariana Dumbledore",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a1097943dc2080021cd8765",
        "house": "unknown",
        "name": "Dudley Dursley",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "muggle",
        "species": "human"
    },
    {
        "_id": "5a1097a23dc2080021cd8766",
        "house": "unknown",
        "name": "Marjorie Dursley",
        "alias": "Marge",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "muggle",
        "species": "human"
    },
    {
        "_id": "5a1097aa3dc2080021cd8767",
        "house": "unknown",
        "name": "Petunia Dursley",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "muggle",
        "species": "human"
    },
    {
        "_id": "5a1097b03dc2080021cd8768",
        "house": "unknown",
        "name": "Vernon Dursley",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "muggle",
        "species": "human"
    },
    {
        "_id": "5a1097d53dc2080021cd8769",
        "house": "unknown",
        "name": "Marietta Edgecombe",
        "role": "student",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1098093dc2080021cd876a",
        "house": "unknown",
        "name": "Everard",
        "role": "(former) Headmaster, Hogwarts",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a10982c3dc2080021cd876b",
        "house": "unknown",
        "name": "Arabella Figg",
        "role": "Dealer of cross-bread cats and kneazies",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "squib",
        "species": "human"
    },
    {
        "_id": "5a1098653dc2080021cd876c",
        "house": "unknown",
        "name": "Argus Filch",
        "role": "Caretaker, Hogwarts",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "squib",
        "species": "human"
    },
    {
        "_id": "5a1098bd3dc2080021cd876d",
        "house": "unknown",
        "name": "Justin Finch-Fletchley",
        "role": "student",
        "house": "Hufflepuff",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "boggart": "Lord Voldemort ",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1098fd3dc2080021cd876e",
        "house": "unknown",
        "name": "Seamus Finnigan",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "boggart": "banshee",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a1099353dc2080021cd876f",
        "house": "unknown",
        "name": "Marcus Flint",
        "role": "student",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a10995b3dc2080021cd8770",
        "house": "unknown",
        "name": "Nicolas Flamel",
        "role": "Alchemist",
        "school": "Beauxbatons Academy of Magic",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1099893dc2080021cd8771",
        "house": "unknown",
        "name": "Mundungus Fletcher",
        "role": "Dealer of Wizarding Artifacts",
        "alias": "Dung",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a1099cf3dc2080021cd8772",
        "house": "unknown",
        "name": "Filius Flitwick",
        "role": "Professor, Charms",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "boggart": "Lord Voldemort",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "part-goblin"
    },
    {
        "_id": "5a1099f93dc2080021cd8773",
        "house": "unknown",
        "name": "Cornelius Fudge",
        "role": "Minister of Magic",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109a1a3dc2080021cd8774",
        "house": "unknown",
        "name": "Marvolo Gaunt",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a109a253dc2080021cd8775",
        "house": "unknown",
        "name": "Merope Gaunt",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a109a2c3dc2080021cd8776",
        "house": "unknown",
        "name": "Morfin Gaunt",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a109a553dc2080021cd8777",
        "house": "unknown",
        "name": "Anthony Goldstein",
        "role": "student",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a109a763dc2080021cd8778",
        "house": "unknown",
        "name": "Goyle Sr.",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a109aa03dc2080021cd8779",
        "house": "unknown",
        "name": "Gregory Goyle",
        "role": "student",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a109af13dc2080021cd877a",
        "house": "unknown",
        "name": "Hermione Granger",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "wand": "Vine wood, 10 3/4\", dragon heartstring",
        "boggart": "failure",
        "patronus": "otter",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "muggle-born",
        "species": "human"
    },
    {
        "_id": "5a109b693dc2080021cd877b",
        "house": "unknown",
        "name": "Mykew Gregorovitch",
        "role": "Wand Maker",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109b873dc2080021cd877c",
        "house": "unknown",
        "name": "Fenrir Greyback",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "unknown",
        "species": "werewolf"
    },
    {
        "_id": "5a109bb33dc2080021cd877d",
        "house": "unknown",
        "name": "Gellert Grindelwald",
        "school": "Durmstrang Institute",
        "alias": "Percival Graves",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109bde3dc2080021cd877e",
        "house": "unknown",
        "name": "Wilhelmina Grubbly-Plank",
        "role": "Professor, Care of Magical Creatures",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109bfc3dc2080021cd877f",
        "house": "unknown",
        "name": "Godric Gryffindor",
        "role": "Founder, Hogwarts",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109c3d3dc2080021cd8780",
        "house": "unknown",
        "name": "Rubeus Hagrid",
        "role": "Groundkeeper, Professor, Care of Magical Creatures",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "wand": "Oak, 16\", unknown core",
        "boggart": "Lord Voldemort",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "half-giant"
    },
    {
        "_id": "5a109c5c3dc2080021cd8781",
        "house": "unknown",
        "name": "Rolanda Hooch",
        "role": "Quidditch Referee ",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109c813dc2080021cd8782",
        "house": "unknown",
        "name": "Mafalda Hopkirk",
        "role": "Assistant, mproper Use of Magic Office",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109c993dc2080021cd8783",
        "house": "unknown",
        "name": "Helga Hufflepuff",
        "role": "Founder, Hogwarts",
        "house": "Hufflepuff",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109cb83dc2080021cd8784",
        "house": "unknown",
        "name": "Angelina Johnson",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109cd33dc2080021cd8785",
        "house": "unknown",
        "name": "Lee Jordan",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "River",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109cf73dc2080021cd8786",
        "house": "unknown",
        "name": "Bertha Jorkins",
        "role": "Department of Magical Games and Sports Employee",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109d2d3dc2080021cd8787",
        "house": "unknown",
        "name": "Igor Karkaroff",
        "role": "Headmaster, Durmstrang",
        "school": "Durmstrang Institute",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109d4a3dc2080021cd8788",
        "house": "unknown",
        "name": "Viktor Krum",
        "role": "Bulgarian Quiddich Seeker",
        "school": "Durmstrang Institute",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109d893dc2080021cd8789",
        "house": "unknown",
        "name": "Bellatrix Lestrange",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Bella",
        "wand": "Walnut, 10 3/4\", dragon heartstring",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a109d9f3dc2080021cd878a",
        "house": "unknown",
        "name": "Rabastan Lestrange",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a109dab3dc2080021cd878b",
        "house": "unknown",
        "name": "Rodolphus Lestrange",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a109de83dc2080021cd878c",
        "house": "unknown",
        "name": "Gilderoy Lockhart",
        "role": "Professor, Defense Against the Dark Arts",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "wand": "Cherry, 9\", dragon heartstring",
        "boggart": "cornish pixies",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a109e143dc2080021cd878d",
        "house": "unknown",
        "name": "Alice Longbottom",
        "role": "Auror (formerly)",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a109e1e3dc2080021cd878e",
        "house": "unknown",
        "name": "Frank Longbottom",
        "role": "Auror (formerly)",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a109e253dc2080021cd878f",
        "house": "unknown",
        "name": "Augusta Longbottom",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a109e543dc2080021cd8790",
        "house": "unknown",
        "name": "Neville Longbottom",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "wand": "Cherry, 13\", unicorn hair",
        "boggart": "Severus Snape",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a109e943dc2080021cd8791",
        "house": "unknown",
        "name": "Luna Lovegood",
        "role": "student",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Loony Lovegood",
        "patronus": "hare",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109ebd3dc2080021cd8792",
        "house": "unknown",
        "name": "Xenophilius Lovegood",
        "role": "Editor, The Quibbler",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Xeno",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109f053dc2080021cd8793",
        "house": "unknown",
        "name": "Remus Lupin",
        "role": "Professor, Defence Against the Dark Arts",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Moony",
        "wand": "Cypress, 10 1/4\", unicorn hair",
        "boggart": "full moon",
        "patronus": "wolf",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "werewolf"
    },
    {
        "_id": "5a109f433dc2080021cd8794",
        "house": "unknown",
        "name": "Walden Macnair",
        "role": "Executioner, Committee of Disposal of Dangerous Creatures",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a109f8b3dc2080021cd8795",
        "house": "unknown",
        "name": "Draco Malfoy",
        "role": "student",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "wand": "Hawthorn, 10\", unicorn hair",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a109fa83dc2080021cd8796",
        "house": "unknown",
        "name": "Lucius Malfoy",
        "role": "School Governer of Hogwarts",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a109fde3dc2080021cd8797",
        "house": "unknown",
        "name": "Narcissa Malfoy",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1222c50f5ae10021650d6d",
        "house": "unknown",
        "name": "Madam Malkin",
        "role": "Shop Owner, Madam Malkin's Robes for All Occasions",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a12231d0f5ae10021650d6e",
        "house": "unknown",
        "name": "Olympe Maxime",
        "role": "Headmistress, Beauxbatons Academy of Magic",
        "school": "Beauxbatons Academy of Magic",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "half-giant",
        "species": "half-giant"
    },
    {
        "_id": "5a1223720f5ae10021650d6f",
        "house": "unknown",
        "name": "Ernest Macmillan",
        "role": "student",
        "house": "Hufflepuff",
        "school": "Hogwarts Academy of Witchcraft and Wizardry",
        "alias": "Ernie",
        "boggart": "Lord Voldemort",
        "patronus": "boar",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1223ed0f5ae10021650d70",
        "house": "unknown",
        "name": "Minerva McGonagall",
        "role": "Professor, Transfiguration",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "wand": "Fir, 9 1/2\", dragon heartstring",
        "boggart": "Lord Voldemort",
        "patronus": "cat",
        "animagus": "tabby cat",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a1225210f5ae10021650d71",
        "house": "unknown",
        "name": "Alastor Moody",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Mad-Eye",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1225640f5ae10021650d72",
        "house": "unknown",
        "name": "Theodore Nott",
        "role": "student",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1225a20f5ae10021650d73",
        "house": "unknown",
        "name": "Garrick Ollivander",
        "role": "Wandmaker",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "wand": "Hornbeam, 12 3/4\", dragon heartstring",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a1225e30f5ae10021650d74",
        "house": "unknown",
        "name": "Pansy Parkinson",
        "role": "student",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a12260f0f5ae10021650d75",
        "house": "unknown",
        "name": "Padma Patil",
        "role": "student",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1226520f5ae10021650d76",
        "house": "unknown",
        "name": "Parvati Patil",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "boggart": "mummy",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1226d70f5ae10021650d77",
        "house": "unknown",
        "name": "Peter Pettigrew",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Wormtail",
        "wand": "Chestnut, 9 1/4, dragon heartstring",
        "boggart": "Lord Voldemort",
        "animagus": "rat",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a12273f0f5ae10021650d78",
        "house": "unknown",
        "name": "Antioch Peverell",
        "wand": "Elder, 15\", Thestral tail hair core",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a12276b0f5ae10021650d79",
        "house": "unknown",
        "name": "Cadmus Peverell",
        "role": "Owner of the resurrection stone",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a12279f0f5ae10021650d7a",
        "house": "unknown",
        "name": "Ignotus Peverell",
        "role": "Owner of the invisibility cloak",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1227e10f5ae10021650d7b",
        "house": "unknown",
        "name": "Irma Pince",
        "role": "Librarian, Hogwarts",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "boggart": "Lord Voldemort",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1228070f5ae10021650d7c",
        "house": "unknown",
        "name": "Sturgis Podmore",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1228930f5ae10021650d7d",
        "house": "unknown",
        "name": "Poppy Pomfrey",
        "role": "Matron, Hogwarts Hospital Wing",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a12292a0f5ae10021650d7e",
        "house": "unknown",
        "name": "Harry Potter",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "The Boy Who Lived",
        "wand": "Holly, 11\", phoenix feather",
        "boggart": "dementor",
        "patronus": "stag",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a12298d0f5ae10021650d7f",
        "house": "unknown",
        "name": "James Potter I",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Prongs",
        "wand": "Mahogany, 11\", unknown core",
        "patronus": "stag",
        "animagus": "stag",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1229e10f5ae10021650d80",
        "house": "unknown",
        "name": "Lily J. Potter",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "wand": "Willow, 10 1/4\", unknown core",
        "patronus": "doe",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "muggle-born",
        "species": "human"
    },
    {
        "_id": "5a122a0e0f5ae10021650d81",
        "house": "unknown",
        "name": "Ernest Prang",
        "role": "Driver of the Knight Bus",
        "alias": "Ernie",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a122a880f5ae10021650d82",
        "house": "unknown",
        "name": "Quirinus Quirrell",
        "role": "Professor, Defence Against the Dark Arts",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "wand": "Alder, 9\", unicorn hair",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a122ac40f5ae10021650d83",
        "house": "unknown",
        "name": "Helena Ravenclaw",
        "role": "Ravenclaw House Ghost",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Grey Lady",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "ghost"
    },
    {
        "_id": "5a122aef0f5ae10021650d84",
        "house": "unknown",
        "name": "Rowena Ravenclaw",
        "role": "Founder, Hogwarts",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a122b320f5ae10021650d85",
        "house": "unknown",
        "name": "Mary Riddle",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "muggle",
        "species": "human"
    },
    {
        "_id": "5a122b510f5ae10021650d86",
        "house": "unknown",
        "name": "Thomas Riddle",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "muggle",
        "species": "human"
    },
    {
        "_id": "5a122b930f5ae10021650d87",
        "house": "unknown",
        "name": "Tom Riddle Sr",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "muggle",
        "species": "human"
    },
    {
        "_id": "5a122c200f5ae10021650d88",
        "house": "unknown",
        "name": "Tom Riddle",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Lord Voldemort",
        "wand": "Yew, 13 1/2\", phoenix feather core",
        "boggart": "his own corpse",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a122cbe0f5ae10021650d89",
        "house": "unknown",
        "name": "Demelza Robins",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a122cf40f5ae10021650d8a",
        "house": "unknown",
        "name": "Augustus Rockwood",
        "role": "Unspeakable",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a122ea30f5ae10021650d8b",
        "house": "unknown",
        "name": "Albert Runcorn",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a122ecc0f5ae10021650d8c",
        "house": "unknown",
        "name": "Scabior",
        "role": "Snatcher",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a122f3d0f5ae10021650d8d",
        "house": "unknown",
        "name": "Newton Scamander ",
        "role": "Author, Fantastic Beasts and Where to Find Them",
        "house": "Hufflepuff",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Newt ",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a122f750f5ae10021650d8e",
        "house": "unknown",
        "name": "Rufus Scrimgeour",
        "role": "Head of Auror Office",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a122fc60f5ae10021650d8f",
        "house": "unknown",
        "name": "Kingsley Shacklebolt",
        "role": "Auror",
        "patronus": "lynx",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1230070f5ae10021650d90",
        "house": "unknown",
        "name": "Stanley Shunpike",
        "role": "Conductor of the Knight Bus",
        "alias": "Stan ",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1230e90f5ae10021650d91",
        "house": "unknown",
        "name": "Aurora Sinistra",
        "role": "Professor, Astronomy",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1231fd0f5ae10021650d92",
        "house": "unknown",
        "name": "Rita Skeeter",
        "role": "Gossip Correspondant for the Daily Prophet",
        "alias": "Queen of the Quills",
        "animagus": "beetle",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1232600f5ae10021650d93",
        "house": "unknown",
        "name": "Horace Slughorn",
        "role": "Professor, Potions",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "wand": "Cedar, 10 1/4\", dragon heartstring",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a12327c0f5ae10021650d94",
        "house": "unknown",
        "name": "Salazar Slytherin",
        "role": "Founder, Hogwarts",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1232b10f5ae10021650d95",
        "house": "unknown",
        "name": "Hepzibah Smith",
        "house": "Hufflepuff",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a12333f0f5ae10021650d96",
        "house": "unknown",
        "name": "Zacharias Smith",
        "role": "student",
        "house": "Hufflepuff",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1233bc0f5ae10021650d97",
        "house": "unknown",
        "name": "Severus Snape",
        "role": "Professor, Potions",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "patronus": "doe",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a1233ff0f5ae10021650d98",
        "house": "unknown",
        "name": "Alicia Spinnet",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1234500f5ae10021650d99",
        "house": "unknown",
        "name": "Pomona Sprout",
        "role": "Professor, Herbology",
        "house": "Hufflepuff",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1234820f5ae10021650d9a",
        "house": "unknown",
        "name": "Pius Thicknesse",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1234cb0f5ae10021650d9b",
        "house": "unknown",
        "name": "Dean Thomas",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "boggart": "severed hand walking on it's own",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a1235060f5ae10021650d9c",
        "house": "unknown",
        "name": "Andromeda Tonks",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1235790f5ae10021650d9d",
        "house": "unknown",
        "name": "Nymphadora Tonks",
        "role": "Auror",
        "house": "Hufflepuff",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Tonks",
        "patronus": "wolf",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human (metamorphmagus)"
    },
    {
        "_id": "5a1235c10f5ae10021650d9e",
        "house": "unknown",
        "name": "Edward Tonks",
        "alias": "Ted",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "muggle-born",
        "species": "human"
    },
    {
        "_id": "5a12361f0f5ae10021650d9f",
        "house": "unknown",
        "name": "Travers",
        "role": "Ministry of Magic Official",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a12368a0f5ae10021650da0",
        "house": "unknown",
        "name": "Sybill Trelawney",
        "role": "Professor, Divination",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "wand": "Hazel, 9 1/2\", unicorn hair",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a1236eb0f5ae10021650da1",
        "house": "unknown",
        "name": "Dolores Umbridge",
        "role": "Head of the Muggle Born Registration Commission",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "wand": "Birch, 8\", dragon heartstring",
        "patronus": "persian cat",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "half-blood",
        "species": "human"
    },
    {
        "_id": "5a1237150f5ae10021650da2",
        "house": "unknown",
        "name": "Emmeline Vance",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1237480f5ae10021650da3",
        "house": "unknown",
        "name": "Romilda Vane",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a12376d0f5ae10021650da4",
        "house": "unknown",
        "name": "Septima Vector",
        "role": "Professor, Arithmancy",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a1237c00f5ae10021650da5",
        "house": "unknown",
        "name": "Arthur Weasley",
        "role": "Head, Misuse of Muggle Artifacts ",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "patronus": "weasel",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1238070f5ae10021650da6",
        "house": "unknown",
        "name": "William Weasley",
        "role": "Curse Breaker, Gringotts Bank",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Bill",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1238350f5ae10021650da7",
        "house": "unknown",
        "name": "Charles Weasley",
        "role": "Dragonologist",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Charlie",
        "wand": "Ash, 12\", unicorn hair tail",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a12387a0f5ae10021650da8",
        "house": "unknown",
        "name": "Fred Weasley",
        "role": "co-owner of Weasleys' Wizard Wheezes",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1238b20f5ae10021650da9",
        "house": "unknown",
        "name": "George Weasley",
        "role": "co-owner of Weasleys' Wizard Wheezes",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1239130f5ae10021650daa",
        "house": "unknown",
        "name": "Ginevra Weasley",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Ginny",
        "patronus": "horse",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a12393d0f5ae10021650dab",
        "house": "unknown",
        "name": "Molly Weasley",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "boggart": "corpses of her family",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a12395f0f5ae10021650dac",
        "house": "unknown",
        "name": "Percy Weasley",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1239c80f5ae10021650dad",
        "house": "unknown",
        "name": "Ronald Weasley",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Ron",
        "wand": "Willow, 14\", unicorn hair tail",
        "boggart": "Aragog",
        "patronus": "jack russell terrier",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": true,
        "dumbledoresArmy": true,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a1239f10f5ae10021650dae",
        "house": "unknown",
        "name": "Oliver Wood",
        "role": "student",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a123a110f5ae10021650daf",
        "house": "unknown",
        "name": "Kennilworthy Whisp",
        "role": "Author, Quiddich Through The Ages",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a123a460f5ae10021650db0",
        "house": "unknown",
        "name": "Corban Yaxley",
        "__v": 0,
        "ministryOfMagic": true,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": true,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a123a710f5ae10021650db1",
        "house": "unknown",
        "name": "Blaise Zabini",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a123a950f5ae10021650db2",
        "house": "unknown",
        "name": "Aragog",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "acromantula"
    },
    {
        "_id": "5a123aa70f5ae10021650db3",
        "house": "unknown",
        "name": "Bane",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "centaur"
    },
    {
        "_id": "5a123ac60f5ae10021650db4",
        "house": "unknown",
        "name": "Beedle the Bard",
        "role": "Fairytale Author",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a123af40f5ae10021650db5",
        "house": "unknown",
        "name": "Bloody Baron",
        "role": "Slytherin House Ghost",
        "house": "Slytherin",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "ghost"
    },
    {
        "_id": "5a123b110f5ae10021650db6",
        "house": "unknown",
        "name": "Buckbeak",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "hippogriff"
    },
    {
        "_id": "5a123b450f5ae10021650db7",
        "house": "unknown",
        "name": "Cadogan",
        "role": "Gryffindor Tower Door Guard",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "pure-blood",
        "species": "human"
    },
    {
        "_id": "5a123bfa0f5ae10021650db8",
        "house": "unknown",
        "name": "Crookshanks",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "cat"
    },
    {
        "_id": "5a123c260f5ae10021650db9",
        "house": "unknown",
        "name": "Dobby",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "house-elf"
    },
    {
        "_id": "5a123c710f5ae10021650dba",
        "house": "unknown",
        "name": "Errol",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "Great Grey Owl"
    },
    {
        "_id": "5a123c8c0f5ae10021650dbb",
        "house": "unknown",
        "name": "Fang",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "Boarhound"
    },
    {
        "_id": "5a123cb40f5ae10021650dbc",
        "house": "unknown",
        "name": "Fat Friar",
        "role": "Hufflepuff House Ghost",
        "house": "Hufflepuff",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "ghost"
    },
    {
        "_id": "5a123cd20f5ae10021650dbd",
        "house": "unknown",
        "name": "Fridfwulfa",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "giant"
    },
    {
        "_id": "5a123cf00f5ae10021650dbe",
        "house": "unknown",
        "name": "Fat Lady",
        "role": "Gryffindor Tower Door Guard",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "portrait"
    },
    {
        "_id": "5a123d3a0f5ae10021650dbf",
        "house": "unknown",
        "name": "Fawkes",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "phoenix"
    },
    {
        "_id": "5a123d520f5ae10021650dc0",
        "house": "unknown",
        "name": "Firenze",
        "role": "Professor, Divination",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "centaur"
    },
    {
        "_id": "5a123d680f5ae10021650dc1",
        "house": "unknown",
        "name": "Fluffy",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "three-headed dog"
    },
    {
        "_id": "5a123d7c0f5ae10021650dc2",
        "house": "unknown",
        "name": "Grawp",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "giant"
    },
    {
        "_id": "5a123d9b0f5ae10021650dc3",
        "house": "unknown",
        "name": "Griphook",
        "role": "Employee, Gringotts Wizarding Bank",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "goblin"
    },
    {
        "_id": "5a123db20f5ae10021650dc4",
        "house": "unknown",
        "name": "Hedwig",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "Snowy Owl"
    },
    {
        "_id": "5a123dc30f5ae10021650dc5",
        "house": "unknown",
        "name": "Hokey",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "house-elf"
    },
    {
        "_id": "5a123de10f5ae10021650dc6",
        "house": "unknown",
        "name": "Kreacher",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "house-elf"
    },
    {
        "_id": "5a123df10f5ae10021650dc7",
        "house": "unknown",
        "name": "Magorian",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "centaur"
    },
    {
        "_id": "5a123e450f5ae10021650dc8",
        "house": "unknown",
        "name": "Myrtle Warren",
        "role": "student",
        "house": "Ravenclaw",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Moaning Myrtle",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "muggle-born",
        "species": "ghost"
    },
    {
        "_id": "5a123e600f5ae10021650dc9",
        "house": "unknown",
        "name": "Mrs. Norris",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "cat"
    },
    {
        "_id": "5a123e870f5ae10021650dca",
        "house": "unknown",
        "name": "Great Aunt Muriel",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a123e9f0f5ae10021650dcb",
        "house": "unknown",
        "name": "Nagini",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "horcrux"
    },
    {
        "_id": "5a123f130f5ae10021650dcc",
        "house": "unknown",
        "name": "Nicholas de Mimsy-Porpington",
        "role": "Gryffindor House Ghost",
        "house": "Gryffindor",
        "school": "Hogwarts School of Witchcraft and Wizardry",
        "alias": "Nearly Headless Nick",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "ghost"
    },
    {
        "_id": "5a123f3b0f5ae10021650dcd",
        "house": "unknown",
        "name": "Norbert",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "Norwegian Ridgeback"
    },
    {
        "_id": "5a123f7c0f5ae10021650dce",
        "house": "unknown",
        "name": "Peeves",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "poltergeist"
    },
    {
        "_id": "5a123f970f5ae10021650dcf",
        "house": "unknown",
        "name": "Pigwidgeon",
        "alias": "Pig",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "scops owl"
    },
    {
        "_id": "5a123fbf0f5ae10021650dd0",
        "house": "unknown",
        "name": "Madam Rosmerta",
        "role": "Owner, The Three Broomsticks",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "human"
    },
    {
        "_id": "5a123fd20f5ae10021650dd1",
        "house": "unknown",
        "name": "Ronan",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "centaur"
    },
    {
        "_id": "5a123fe30f5ae10021650dd2",
        "house": "unknown",
        "name": "Trevor",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "toad"
    },
    {
        "_id": "5a123fff0f5ae10021650dd3",
        "house": "unknown",
        "name": "Winky",
        "__v": 0,
        "ministryOfMagic": false,
        "orderOfThePhoenix": false,
        "dumbledoresArmy": false,
        "deathEater": false,
        "bloodStatus": "unknown",
        "species": "house-elf"
    }
]